/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  Address,
  AddressFromJSON,
  AddressToJSON,
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  PaymentMethodKey,
  PaymentStatusKey,
} from './'

/**
 *
 * @export
 * @interface LicensingPaymentBase
 */
export interface LicensingPaymentBase {
  /**
   *
   * @type number
   * @memberof LicensingPaymentBase
   */
  paymentKey: number
  /**
   *
   * @type Date
   * @memberof LicensingPaymentBase
   */
  begunAt: Date
  /**
   *
   * @type number
   * @memberof LicensingPaymentBase
   */
  userKey: number
  /**
   *
   * @type PaymentMethodKey
   * @memberof LicensingPaymentBase
   */
  paymentMethodKey: PaymentMethodKey
  /**
   *
   * @type CashAmount
   * @memberof LicensingPaymentBase
   */
  amount: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof LicensingPaymentBase
   */
  tax: CashAmount
  /**
   *
   * @type string
   * @memberof LicensingPaymentBase
   */
  taxTransactionId?: string
  /**
   *
   * @type CashAmount
   * @memberof LicensingPaymentBase
   */
  total?: CashAmount
  /**
   *
   * @type string
   * @memberof LicensingPaymentBase
   */
  orderId?: string
  /**
   *
   * @type PaymentStatusKey
   * @memberof LicensingPaymentBase
   */
  paymentStatusKey: PaymentStatusKey
  /**
   *
   * @type Address
   * @memberof LicensingPaymentBase
   */
  address?: Address
  /**
   *
   * @type string
   * @memberof LicensingPaymentBase
   */
  desc?: string
  /**
   *
   * @type string
   * @memberof LicensingPaymentBase
   */
  paymentProviderId?: string
  /**
   * The payment cornerstone transaction id.
   * @type string
   * @memberof LicensingPaymentBase
   */
  transactionId?: string
  /**
   * Username of the actor who made the payment.
   * @type string
   * @memberof LicensingPaymentBase
   */
  paidBy?: string
  /**
   * Whether the user can edit the payment or not.
   * @type boolean
   * @memberof LicensingPaymentBase
   */
  canUserEdit?: boolean
}

export function LicensingPaymentBaseFromJSON(json: any): LicensingPaymentBase {
  return LicensingPaymentBaseFromJSONTyped(json, false)
}

export function LicensingPaymentBaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LicensingPaymentBase {
  if (json === undefined || json === null) {
    return json
  }
  return {
    paymentKey: json['paymentKey'],
    begunAt: new Date(json['begunAt']),
    userKey: json['userKey'],
    paymentMethodKey: json['paymentMethodKey'],
    amount: CashAmountFromJSON(json['amount']),
    tax: CashAmountFromJSON(json['tax']),
    taxTransactionId: !exists(json, 'taxTransactionId')
      ? undefined
      : json['taxTransactionId'],
    total: !exists(json, 'total')
      ? undefined
      : CashAmountFromJSON(json['total']),
    orderId: !exists(json, 'orderId') ? undefined : json['orderId'],
    paymentStatusKey: json['paymentStatusKey'],
    address: !exists(json, 'address')
      ? undefined
      : AddressFromJSON(json['address']),
    desc: !exists(json, 'desc') ? undefined : json['desc'],
    paymentProviderId: !exists(json, 'paymentProviderId')
      ? undefined
      : json['paymentProviderId'],
    transactionId: !exists(json, 'transactionId')
      ? undefined
      : json['transactionId'],
    paidBy: !exists(json, 'paidBy') ? undefined : json['paidBy'],
    canUserEdit: !exists(json, 'canUserEdit') ? undefined : json['canUserEdit'],
  }
}

export function LicensingPaymentBaseToJSON(
  value?: LicensingPaymentBase | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    paymentKey: value.paymentKey,
    begunAt: value.begunAt.toISOString().substr(0, 10),
    userKey: value.userKey,
    paymentMethodKey: value.paymentMethodKey,
    amount: CashAmountToJSON(value.amount),
    tax: CashAmountToJSON(value.tax),
    taxTransactionId: value.taxTransactionId,
    total: CashAmountToJSON(value.total),
    orderId: value.orderId,
    paymentStatusKey: value.paymentStatusKey,
    address: AddressToJSON(value.address),
    desc: value.desc,
    paymentProviderId: value.paymentProviderId,
    transactionId: value.transactionId,
    paidBy: value.paidBy,
    canUserEdit: value.canUserEdit,
  }
}
